(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-page-parallax"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const parallax = document.querySelector(".parallax-section .parallax-image");

  function updateParallax() {
    let scrolled = window.pageYOffset;
    let sectionTop = parallax.parentElement.offsetTop;
    let sectionHeight = parallax.parentElement.offsetHeight;
    let windowHeight = window.innerHeight;

    // only run while section is in view
    if (scrolled + windowHeight > sectionTop && scrolled < sectionTop + sectionHeight) {
      let yOffset = (scrolled - sectionTop) * 0.4; // parallax speed
      parallax.style.transform = `translateY(${yOffset}px)`;
    }
    requestAnimationFrame(updateParallax);
  }

  requestAnimationFrame(updateParallax);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sidebars = document.querySelectorAll('.custom-faq .faq__sidebar');
  if (!sidebars.length) return;

  const TOP_OFFSET = 30;

  sidebars.forEach(sidebar => {
    const container = sidebar.closest('.faq');
    if (!container) return;

    const toc = sidebar.querySelector('.faq__toc');
    if (!toc) return;

    const tocLinks = toc.querySelectorAll('.faq__toc-item');
    const categories = [];

    tocLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (href?.startsWith('#')) {
        const element = document.getElementById(href.substring(1));
        if (element) categories.push({ link, element });
      }
    });

    const rect = sidebar.getBoundingClientRect();
    const initialLeft = rect.left;
    const fixedWidth = rect.width;

    function updateActiveLink() {
      const triggerPoint = window.pageYOffset + TOP_OFFSET + 100;
      let activeIndex = 0;

      for (let i = 0; i < categories.length; i++) {
        const currentTop = categories[i].element.getBoundingClientRect().top + window.pageYOffset;
        const nextTop = categories[i + 1] ? categories[i + 1].element.getBoundingClientRect().top + window.pageYOffset : Infinity;

        if (triggerPoint >= currentTop && triggerPoint < nextTop) {
          activeIndex = i;
          break;
        }
      }

      categories.forEach((cat, index) => {
        cat.link.classList.toggle('is-active', index === activeIndex);
      });
    }

    function updateSidebar() {
      if (window.innerWidth <= 767) {
        sidebar.style.cssText = '';
        return;
      }

      const docScroll = window.pageYOffset;
      const containerTop = container.offsetTop;
      const containerBottom = containerTop + container.offsetHeight;
      const fixPoint = containerTop - TOP_OFFSET;
      const stopFixPoint = containerBottom - TOP_OFFSET - sidebar.offsetHeight;

      if (docScroll < fixPoint) {
        sidebar.style.cssText = `position: absolute; top: 0; left: auto; right: 0; width: ${fixedWidth}px;`;
      } else if (docScroll <= stopFixPoint) {
        sidebar.style.cssText = `position: fixed; top: ${TOP_OFFSET}px; left: ${initialLeft}px; width: ${fixedWidth}px;`;
      } else {
        sidebar.style.cssText = `position: absolute; top: ${container.offsetHeight - sidebar.offsetHeight}px; left: auto; right: 0; width: ${fixedWidth}px;`;
      }

      updateActiveLink();
    }

    window.addEventListener('scroll', updateSidebar, { passive: true });
    window.addEventListener('resize', updateSidebar);
    
    setTimeout(updateSidebar, 100);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
